import { getApp, getApps, initializeApp } from "firebase/app";
import { Analytics, getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAPlDqz55D7WxTIXAtSlChDEebdjfQYQYQ",
  authDomain: "kanatomo-f0183.firebaseapp.com",
  projectId: "kanatomo-f0183",
  storageBucket: "kanatomo-f0183.firebasestorage.app",
  messagingSenderId: "680717520303",
  appId: "1:680717520303:web:d6d990fa60c5afc7f4f35a",
  measurementId: "G-KQN7YMLPTE",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let analyticsPromise: Promise<Analytics | null> | null = null;

const getFirebaseAnalytics = (): Promise<Analytics | null> => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch(() => null);
  }

  return analyticsPromise;
};

export const trackPageView = (pagePath: string): void => {
  void getFirebaseAnalytics().then((analytics) => {
    if (!analytics) return;

    logEvent(analytics, "page_view", {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  });
};

type StoreClickParams = {
  app_name: "kanatomo" | "lunatarot" | "addup" | "stirred";
  store_name: "app_store" | "google_play";
  source_page: string;
};

export const trackStoreClick = (params: StoreClickParams): void => {
  void getFirebaseAnalytics().then((analytics) => {
    if (!analytics) return;

    logEvent(analytics, "store_click", params);
  });
};
